import { Trans } from '@lingui/react';
import cx from 'classnames';
import { useEffect, useState } from 'react';
import Collapsable from '../Collapsable';
import { useAppConfiguration } from '../hooks/useAppConfiguration';
import { mailCheck } from './mailcheck';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const initialSuggestion = {
  address: '',
  domain: '',
  full: ''
};
export function EmailSuggestion(_ref) {
  let {
    email,
    className,
    setEmail,
    renderLabel = email => {
      return /*#__PURE__*/_jsx(Trans, {
        id: "selfInspection.emailSuggestion.label",
        values: {
          email
        }
      });
    },
    buttonText = /*#__PURE__*/_jsx(Trans, {
      id: "selfInspection.emailSuggestion.buttonText"
    })
  } = _ref;
  const [suggestion, clear] = useEmailCheck(email);
  const {
    full
  } = suggestion;
  function onClickHandler(e) {
    e.preventDefault();
    setEmail(full);
    clear();
  }
  return /*#__PURE__*/_jsx(Collapsable, {
    closed: full === '',
    duration: 80,
    closeDelay: 0,
    children: /*#__PURE__*/_jsx("div", {
      className: cx('email-suggestion', className),
      children: /*#__PURE__*/_jsxs("span", {
        style: {
          opacity: full === '' ? 0 : 1
        },
        children: [/*#__PURE__*/_jsx("span", {
          children: renderLabel?.(full)
        }), ' ', /*#__PURE__*/_jsx("button", {
          className: cx('email-suggestion__button'),
          type: "button",
          onClick: onClickHandler,
          children: buttonText
        })]
      })
    })
  });
}
export function useEmailCheck(email) {
  const {
    locale
  } = useAppConfiguration();
  const [suggestion, setSuggestion] = useState(initialSuggestion);
  useEffect(function emailChangeEffect() {
    mailCheck({
      locale,
      email,
      suggested: suggestion => {
        if (suggestion.address !== undefined) {
          setSuggestion(suggestion);
        }
      },
      empty() {
        setSuggestion(initialSuggestion);
      }
    });
  }, [email, locale]);
  function empty() {
    setSuggestion(initialSuggestion);
  }
  return [suggestion, empty];
}